export const config = {
  apiBaseUrl:
    process.env.REACT_APP_API_URL || "https://integration-api.wingspan.app"
};
